var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('LoadingSkeleton',{attrs:{"width":"100%","height":"320px","radius":"0"}}):_c('ProfileSubscriptions',{attrs:{"subscriptions":_vm.subscriptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }